import {Component, Input, OnInit} from '@angular/core';
import {Result} from '../../../models/Poll';

@Component({
  selector: 'app-poll-results-rature-result',
  templateUrl: './poll-results-rature-result.component.html',
  styleUrls: ['./poll-results-rature-result.component.less']
})
export class PollResultsRatureResultComponent implements OnInit {
  @Input() result: Result;
  choice: string;
  // fillValue: number;

  ngOnInit() {
    this.choice = this.result.text;
    // this.fillValue = 100 - this.result.percentage;
  }

}
